import store from '@/store';

export const registerStore = (name: string, module: any) => {
  if (module.store) {
    store.registerModule(name, module.store);
  }
};
